export const formatForExcel1 = (data) => {
  const aoa = [];

  data.forEach((invoice) => {
    // Add Invoice Header
    const invoiceHeader = ["Individual Invoice Amount", "Invoice Date", "Invoice Number", "PO Number", "Vendor Name"];
    aoa.push(invoiceHeader);

    // Add Invoice Row
    aoa.push([
      invoice.INDIVIDUAL_INVOICE_AMT || "",
      invoice.INVOICE_DATE || "",
      invoice.INVOICE_NUMBER || "",
      invoice.PO_NUMBER || "",
      invoice.VENDOR_NAME || "",
    ]);

    const payments = invoice.PAYMENT_LIST || [];

    if (
      !payments.length ||
      payments.every((p) => !p.PAYMENT_MODE || p.PAYMENT_MODE === "No Payment Info")
    ) {
      // Only Payment Mode + No Payment Info
      aoa.push(["", "", "", "", "Payment Mode"]);
      aoa.push(["", "", "", "", "No Payment Info"]);
    } else {
      // Add Payment Header Row
      aoa.push(["", "", "", "",
        "Payment Mode",
        "Pay Amount",
        "Accounting Date",
        "Payment Date",
        "Payment Number"
      ]);

      // Add Each Payment Row
      payments.forEach((p) => {
        aoa.push(["", "", "", "",
          p.PAYMENT_MODE || "",
          p.PAYMENT_AMT || "",
          p.ACCOUNTING_DATE || "",
          p.CHEQUE_DATE || "",
          p.CHEQUE_NUMBER || "",
        ]);
      });
    }

    // Spacer
    aoa.push([]);
  });

  return aoa;
};
